(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["morphano-packs"] && !Shopify.designMode) return;
  try {
    function syncMorphanoPricing(container) {
  const option = container.querySelector('.shopify_subscriptions_app_container input[type="radio"]:checked');
  const plan = option?.dataset.sellingPlanId || '';
  container.querySelectorAll('[data-morphano-plan]').forEach((element) => { element.hidden = element.dataset.morphanoPlan !== plan; });
  container.querySelectorAll('[data-morphano-note]').forEach((element) => { element.hidden = !!plan; });
  container.querySelectorAll('[data-morphano-sub-note]').forEach((element) => { element.hidden = !plan; });
}
document.addEventListener('change', (event) => {
  const container = event.target.closest('product-info');
  if (container && event.target.matches('.shopify_subscriptions_app_container input[type="radio"]')) syncMorphanoPricing(container);
});
function refineMorphanoSubscriptionCopy(container) {
  const copy = {
    'Automatic renewal, skip or cancel anytime.': 'Automatic renewal. Cancel anytime.',
    'Automatische Verlängerung, jederzeit überspringen oder kündigen.': 'Automatische Verlängerung. Jederzeit kündbar.'
  };
  const subscriptionBlock = container.querySelector('.shopify_subscriptions_app_container');
  if (!subscriptionBlock) return;
  const walker = document.createTreeWalker(subscriptionBlock, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    const replacementText = copy[node.textContent.trim()];
    if (replacementText) node.textContent = replacementText;
  }
}
function observeMorphanoSubscriptionCopy(container) {
  if (container.dataset.morphanoSubscriptionCopyObserver) return;
  const subscriptionBlock = container.querySelector('.shopify_subscriptions_app_container');
  if (!subscriptionBlock) return;
  const observer = new MutationObserver(() => refineMorphanoSubscriptionCopy(container));
  observer.observe(subscriptionBlock, { childList: true, subtree: true, characterData: true });
  container.dataset.morphanoSubscriptionCopyObserver = 'true';
}
function initMorphanoPricing() {
  document.querySelectorAll('product-info').forEach((container) => {
    syncMorphanoPricing(container);
    refineMorphanoSubscriptionCopy(container);
    observeMorphanoSubscriptionCopy(container);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMorphanoPricing); else initMorphanoPricing();
document.addEventListener('shopify:section:load', initMorphanoPricing);
window.addEventListener('pageshow', initMorphanoPricing);
  } catch(e) { console.error(e); }
})();

})();
